"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Divider;

var _DividerModule = _interopRequireDefault(require("../../assets/styles/components/Divider.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Divider(_ref) {
  let {
    styling = {},
    orientation = "horizontal"
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: styling,
      className: "\n        ".concat(_DividerModule.default.divider, "\n        ").concat(orientation === "horizontal" ? _DividerModule.default.orientation_horizontal : orientation === "vertical" ? _DividerModule.default.orientation_vertical : _DividerModule.default.orientation_horizontal, "\n        ")
    })
  });
}